import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { TransactionRequest } from './TransactionRequest'
import { PrivateKey } from '../wallet/PrivateKey'

const SignedTransactionPropsSchema = z.object({
  transactionRequest: z.instanceof(TransactionRequest),
  privateKey: z.instanceof(PrivateKey),
})

type SignedTransactionProps = z.infer<typeof SignedTransactionPropsSchema>

export class SignedTransaction extends ValueObject<SignedTransactionProps> {
  public getSerializedValue(): HexNumber {
    const typedTransaction = this.props.transactionRequest.getTypedTransaction()
    const signedTransaction = typedTransaction.sign(
      this.props.privateKey.getValue()
    )
    const serializedTransaction = signedTransaction.serialize().toString('hex')
    return HexNumber.create({ hexNumberValue: `0x${serializedTransaction}` })
  }

  public static create(props: SignedTransactionProps): SignedTransaction {
    const validatedProps = SignedTransactionPropsSchema.parse(props)
    return new SignedTransaction(validatedProps)
  }
}
